import { h } from 'vue'
import type { IconSet } from 'vuetify'

// Import *all* filled SVGs at build time
const filledIcons = import.meta.glob('../assets/healthicons/*.svg', {
    eager: true,
    import: 'default',
})

export const healthicons: IconSet = {
    component: (props) => {
        const name = props.icon as string
        let path = `../assets/healthicons/${name}.svg`
        let icon = filledIcons[path]

        if (!icon) {
            console.warn(`[HealthIcons] Icon not found: ${name}`)
            path = `../assets/healthicons/Question Mark.svg`
            icon = filledIcons[path]
        }

        return h('img', {
            src: icon,
            alt: name,
            style: {
                width: '1em',
                height: '1em',
                verticalAlign: 'middle',
            },
        })
    },
}
